<template>
  <div class="c-convincing-deactivating-list">
    <h6 class="title is-spaced">Aqui você também pode resgatar em produtos!</h6>
    <p class="subtitle is-medium">Conheça o Shopping Casar.com!</p>
    <p class="subtitle">
      Com o Shopping Casar.com você tem a opção de resgatar o saldo da sua lista
      de presentes em produtos e ainda ganhar 4% de cashback em cada compra.
    </p>
    <p class="subtitle empashis">
      <strong>Aproveite as ofertas exclusivas dos nossos parceiros!</strong>
    </p>

    <BasePartnersShopping class="partners" withBordered />

    <a
      @click="$emit('keepList')"
      href="https://ajuda.casar.com/support/solutions/articles/73000559547-como-funciona-o-shopping-casar-com-"
      target="_blank"
      class="button is-primary"
    >
      Quero saber mais sobre o Shopping Casar.com
    </a>
    <p>
      <a @click="$emit('disableList')" class="link" href="#">
        Quero desativar a minha lista de presentes
      </a>
    </p>
  </div>
</template>

<script>
import BasePartnersShopping from '../../BasePartnersShopping.vue'

export default {
  components: {
    BasePartnersShopping,
  },

  data() {
    return {}
  },

  methods: {},
}
</script>

<style lang="scss">
.c-convincing-deactivating-list {
  .subtitle.empashis {
    margin: 48px 0;
  }

  .partners {
    padding: 0;
    margin-bottom: 48px;
  }
}
</style>
